import { useEffect, useRef } from "react";

// Web Speech API tabanlı sürekli dinleme motoru.
// enabled değiştiğinde motoru başlatır/durdurur, sonuçları onResult'a iletir.
export function useVoiceEngine({ enabled, onResult, onUnsupported }) {
  const recRef = useRef(null);
  const enabledRef = useRef(enabled);
  const cbRef = useRef({ onResult, onUnsupported });

  enabledRef.current = enabled;
  cbRef.current = { onResult, onUnsupported };

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      cbRef.current.onUnsupported && cbRef.current.onUnsupported();
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "tr-TR";
    recognition.continuous = true;
    recognition.interimResults = false;

    recognition.onresult = function (event) {
      const speechResult = event.results[event.results.length - 1][0].transcript.trim();
      if (cbRef.current.onResult) cbRef.current.onResult(speechResult);
    };

    recognition.onerror = function () {};

    recognition.onend = function () {
      if (enabledRef.current) {
        try {
          recognition.start();
        } catch (e) {}
      }
    };

    recRef.current = recognition;

    if (enabledRef.current) {
      try {
        recognition.start();
      } catch (e) {}
    }

    return () => {
      enabledRef.current = false;
      try {
        recognition.stop();
      } catch (e) {}
      recRef.current = null;
    };
  }, []);

  useEffect(() => {
    const rec = recRef.current;
    if (!rec) return;
    if (enabled) {
      try {
        rec.start();
      } catch (e) {}
    } else {
      try {
        rec.stop();
      } catch (e) {}
    }
  }, [enabled]);
}
